<template>
  <v-container class="" fluid style="min-height:100vh">
    <v-row>
      <v-col class="ma-auto">
        <v-container>
          <v-row>
            <v-col>
        <h1 class="" v-if="$vuetify.breakpoint.mdAndUp">Check out my music!</h1>
        <h1 style="text-align:center" v-else>Check out my music!</h1>
        <v-expansion-panels accordion v-model="panel" multiple>
          <v-expansion-panel >
            <v-expansion-panel-header >
              <span><font-awesome-icon :icon="['fab', 'soundcloud']" class="mr-4" />SoundCloud</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <iframe width="100%" height="300px" :class="{ 'mobile-player': $vuetify.breakpoint.xs }" scrolling="no"
                frameborder="no" allow="autoplay"
                src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/294262&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=false">
              </iframe>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span><font-awesome-icon :icon="['fab', 'spotify']" class="mr-4" />Spotify</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <iframe style="border-radius:12px"
                src="https://open.spotify.com/embed/artist/19kHmmMlAlaB4agizfXRof?utm_source=generator&theme=0"
                width="100%" height="352" frameBorder="0" allowfullscreen=""
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"></iframe>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span><font-awesome-icon :icon="['fab', 'apple']" class="mr-4" />Apple Music</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <iframe allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameborder="0" height="450"
                style="width:100%;overflow:hidden;border-radius:10px;"
                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
                src="https://embed.music.apple.com/it/playlist/its-fred-dope/pl.u-XkD0vBBsRVRMb2"></iframe>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
          </v-row>
      </v-container>
      </v-col>
    </v-row>
  </v-container></template>

<script>
// @ is an alias to /src


export default {
  name: 'Music',
  data: () => ({
      panel: [0],
    }),
  components: {
  }
}
</script>
<style scoped>
.mobile-player {
    height: 400px
}
</style>